import acrossPic from '../assets/images/acrossPic.png';
import cplus from '../assets/images/c++.png';
import html from "../assets/images/html5.png"
import css from "../assets/images/css3.png"
import bootstrap from "../assets/images/bootstrap-removebg-preview.png"
import javascript from "../assets/images/javascript.png"
import reactjs from "../assets/images/react-removebg-preview.png"
import nodejs from "../assets/images/nodejs-removebg-preview.png"
import express from "../assets/images/express-removebg-preview.png"
import mongo from "../assets/images/mongo-removebg-preview.png"
import mySql from "../assets/images/mysql-removebg-preview.png"
import c from "../assets/images/c.png"
import python from '../assets/images/python.png'
import vscode from "../assets/images/vs-code.png"
import git from "../assets/images/git.png"
import github from "../assets/images/GitHub.png"
import postman from "../assets/images/post.png"



export const Data=[
    {
        id:1,
        title:"ACROSS THE GLOBE",
        img:acrossPic,
        desc:"Worked with PHP/Laravel Syntax , developed frontend according to the design and used animation libraries like Gsap",
        link:"https://www.atg.world/",
        skills:["HTML", "CSS", "JAVASCRIPT", "PHP", "LARAVEL"]
    },
    {
        id:2,
        title:"ACROSS THE GLOBE",
        img:acrossPic,
        desc:"Worked with PHP/Laravel Syntax , developed frontend according to the design and used animation libraries like Gsap",
        link:"https://www.atg.world/",
        skills:["HTML", "CSS", "JAVASCRIPT", "PHP", "LARAVEL"]
    },
    {
        id:3,
        title:"ACROSS THE GLOBE",
        img:acrossPic,
        desc:"Worked with PHP/Laravel Syntax , developed frontend according to the design and used animation libraries like Gsap",
        link:"https://www.atg.world/",
        skills:["HTML", "CSS", "JAVASCRIPT", "PHP", "LARAVEL"]
    },
    {
        id:4,
        title:"ACROSS THE GLOBE",
        img:acrossPic,
        desc:"Worked with PHP/Laravel Syntax , developed frontend according to the design and used animation libraries like Gsap ",
        link:"https://www.atg.world/",
        skills:["HTML", "CSS", "JAVASCRIPT", "PHP", "LARAVEL"]
    },
    {
        id:5,
        title:"ACROSS THE GLOBE",
        img:acrossPic,
        desc:"Worked with PHP/Laravel Syntax , developed frontend according to the design and used animation libraries like Gsap",
        link:"https://www.atg.world/",
        skills:["HTML", "CSS", "JAVASCRIPT", "PHP", "LARAVEL"]
    },
    {
        id:6,
        title:"ACROSS THE GLOBE",
        img:acrossPic,
        desc:"Worked with PHP/Laravel Syntax , developed frontend according to the design and used animation libraries like Gsap",
        link:"https://www.atg.world/",
        skills:["HTML", "CSS", "JAVASCRIPT", "PHP", "LARAVEL"]
    },
]

export const development=[
    {
        pic:html,
        title:"HTML"
    },
    {
        pic:css,
        title:"CSS"
    },
    {
        pic:bootstrap,
        title:"BOOTSTRAP"
    },
    {
        pic:javascript,
        title:"JAVASCRIPT"
    },
    {
        pic:reactjs,
        title:"REACT JS"
    },
    {
        pic:nodejs,
        title:"NODE JS"
    },
    {
        pic:express,
        title:"EXPRESS JS"
    },
    {
        pic:mongo,
        title:"MongoDb"
    },
    {
        pic:mySql,
        title:"MySql"
    }
]
export const programming=[
    {
        pic:cplus,
        title:"C++"
    },
    {
        pic:c,
        title:"C"
    },
    {
        pic:python,
        title:"PYTHON"
    },
    {
        pic:javascript,
        title:"JAVASCRIPT"
    },
]
export const tools=[
    {
        pic:git,
        title:"Git"
    },
    {
        pic:github,
        title:"GITHUB"
    },
    {
        pic:vscode,
        title:"VS CODE"
    },
    {
        pic:postman,
        title:"POSTMAN"
    },
]
